import styled from '@emotion/styled';
import { PaginationWrap } from './Pagination.styles';
import TextAndButton from '../button/TextAndButton';
import { ArrowBackIcon, Responsive } from '../../../ui';
import { Color } from '../../../styles/Color';

interface IProps {
	currentPageIndex: number;
	totalPages: number;
	getHref: (page: number) => string;
}

export function Pagination({ currentPageIndex, totalPages, getHref }: IProps) {
	const isMobile = !!Responsive.useMatchesBreakpoint('mobileXL');
	const prevIndex = currentPageIndex - 1;
	const prevDisabled = currentPageIndex === 0;
	const prevHref = prevDisabled ? '' : getHref(prevIndex);

	const nextIndex = currentPageIndex + 1;
	const nextDisabled = currentPageIndex === totalPages - 1;
	const nextHref = nextDisabled ? '' : getHref(nextIndex);

	return (
		<PaginationWrap>
			<TextAndButton
				label="Back"
				href={prevHref}
				aria-disabled={prevDisabled}
				disabled={prevDisabled}
				aria-label="Back"
				textPosition="right"
				icon={ArrowBackIcon}
				hideLabel={isMobile}
			/>

			<PageCount>
				{nextIndex} of {totalPages} pages
			</PageCount>

			<TextAndButton
				label="Next"
				href={nextHref}
				aria-disabled={nextDisabled}
				disabled={nextDisabled}
				aria-label={`Next ${currentPageIndex + 1}/${totalPages}`}
				hideLabel={isMobile}
			/>
		</PaginationWrap>
	);
}

const PageCount = styled.div`
	display: none;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: flex;
		flex-direction: column;
		justify-content: center;
		color: ${Color.OnBackground2};
		font-weight: 400;
	}
`;
